export function appendToPaginatedItems<T extends object>(
  pageSize: number,
  items: T[],
  new_item: T
) {
  if (items.length == pageSize)
    return [new_item, ...items.slice(0, items.length - 1)];
  return [new_item, ...items];
}
